// import { Breadcrumb } from "antd";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";

export default function BreadCrumbComponent({
  txtFirst,
  txtSecond,
  txtThir,
  goback,
}) {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          marginBottom: 20,
          padding: 10,
          backgroundColor: "#fff",
          fontSize: 25,
          // top: 0,
          // left: 0,
          // zIndex: 9999,
          width: "100%",
        }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            sx={{ cursor: "pointer" }}
            color="inherit"
            onClick={goback}>
            {txtFirst}
          </Link>
          <Typography color="text.primary">
            <span>{txtSecond}</span>
          </Typography>
          {txtThir && <Typography color="text.primary">
            <span>{txtThir}</span>
          </Typography>}
        </Breadcrumbs>
      </div>
    </>
  );
}
